<template lang="pug">
.expand_menu.d-lg-none
  //- 大分類
  .list_item(
    v-for="(group, gi) in links",
    :key="group.name || gi",
    :class="{ expand: !!group.isExpand }"
  )
    .title.d-flex.justify-content-between.align-items-center(
      @click="$emit('toggle', gi)"
    )
      h5 {{ group.name }}
      svg-icon(iconClass="arrow_bottom_g", className="arrow_bottom_g")

    //- 子分類
    ul.content(v-if="Array.isArray(group.children) && group.children.length")
      li(
        v-for="(node, ci) in group.children",
        :key="(group.name || gi) + '-node-' + ci",
        :class="{ 'category-block': Array.isArray(node.list) && node.list.length, 'single-block': !(Array.isArray(node.list) && node.list.length), expand: !!node.isExpand }"
      )
        //- 有子清單的分類
        template(v-if="Array.isArray(node.list) && node.list.length")
          button.category-title.d-flex.justify-content-between.align-items-center(
            type="button",
            @click="$emit('toggle-child', { gi: gi, ci: ci })"
          )
            span {{ node.name }}
            svg-icon(iconClass="arrow_bottom_g", className="arrow_bottom_sub")

          ul.category-children-block(v-show="node.isExpand")
            li(
              v-for="(item, ii) in node.list",
              :key="(group.name || gi) + '-node-' + ci + '-item-' + ii"
            )
              a(:href="item.url") {{ item.name }}

        //- 沒有子清單的分類
        a(v-else, :href="node.url") {{ node.name }}
</template>

<script>
export default {
  name: "ExpandMenu",
  props: {
    links: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/more";

.expand_menu {
  background: #fff;
}

/* ---------- 大分類樣式 ---------- */
.list_item {
  width: 100%;
  border-bottom: 1px solid $color_blue_btn_ci;
  background: #fff;
  padding: 16px 0;

  h5 {
    @include font(20px, $color_black_text, bold);
  }

  .title {
    padding: 0 16px;
    cursor: pointer;
  }

  .arrow_bottom_g {
    color: #0082c0;
    width: 26px;
    transition: transform 0.3s ease;
  }

  &.expand {
    border: none;

    .content {
      display: block;
      border-top: 1px solid $color_blue_btn_ci;
    }

    .arrow_bottom_g {
      transform: rotate(180deg);
    }
  }

  &:nth-child(even) {
    background-color: #f9f9fa;
  }

  /* ---------- 子分類樣式 ---------- */
  .content {
    display: none;
    margin-top: 15px;
    list-style: none;
    padding: 16px 16px 0;

    li {
      padding: 8px 0;
    }

    a {
      color: #4f4f4f;
    }

    .category-block {
      border-bottom: 1px solid #e8e8e8;

      .category-title {
        width: 100%;
        background: transparent;
        border: 0;
        font-weight: 700;
        font-size: 16px;
        color: #3197fa;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: 0;
        margin-bottom: 4px;

        /* 小分類箭頭樣式 */
        .arrow_bottom_sub {
          width: 18px;
          color: #B4CEE7;
          transition: transform 0.3s ease;
        }
      }

      .category-children-block {
        list-style: none;
      }

      /* 展開時小箭頭旋轉 */
      &.expand .arrow_bottom_sub {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
